import { Container } from "react-bootstrap";

const NotFound = () => {
    return ( 
        <Container>
            <h1>404 Page Not Found</h1>
        </Container>
    )
};

export default NotFound;
